import React from "react";
import { Modal, Tabs, Tab, Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import "yup-phone";
import ParentTabFields from "./ParentTabFields";
import EmergencyTabFields from "./EmergencyTabFields";
import DoctorTabFields from "./DoctorTabFields";
import OthersTabFields from "./OthersTabFields";

export default function ParentEditModal({
  data,
  show,
  handleClose,
  handleParentUpdate,
}) {
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid Email").required("Required"),
    guardianPhone1: Yup.string()
      .required("Required")
      .phone("UK", false, "Invalid Phone Number"),
    guardianPhone2: Yup.string()
      .required("Required")
      .phone("UK", false, "Invalid Phone Number"),
    guardianAddress1: Yup.string().required("Required"),
    guardianCity: Yup.string().required("Required"),
    guardianPostcode: Yup.string()
      .required("Required")
      .matches(
        "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
        "Invalid Postcode"
      ),
    emergencyFirstName: Yup.string().required("Required"),
    emergencyLastName: Yup.string().required("Required"),
    emergencyPhone: Yup.string()
      .required("Required")
      .phone("UK", false, "Invalid Phone Number"),
    emergencyRelation: Yup.string().required("Required"),
    emergencyAddress1: Yup.string().required("Required"),
    emergencyCity: Yup.string().required("Required"),
    emergencyPostcode: Yup.string()
      .required("Required")
      .matches(
        "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
        "Invalid Postcode"
      ),
    doctorName: Yup.string().required("Required"),
    doctorAddress1: Yup.string().required("Required"),
    doctorCity: Yup.string().required("Required"),
    doctorPostcode: Yup.string()
      .required("Required")
      .matches(
        "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
        "Invalid Postcode"
      ),
    doctorPhone: Yup.string()
      .required("Required")
      .phone("UK", false, "Invalid Phone Number"),
    otherPrecautions: Yup.string().required("Required"),
    otherInternetAccess: Yup.string().required("Required"),
    otherLeadSource: Yup.string().required("Required"),
    otherVolunteer: Yup.string().required("Required"),
    otherEthnicity: Yup.string().required("Required"),
  });

  return (
    <Modal
      show={show}
      size="lg"
      onHide={handleClose}
      centered
      className="parent-view-modal max-heighted-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Details</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleParentUpdate(data.userId, values, setSubmitting);
          handleClose();
        }}
      >
        {({
          values,
          setFieldValue,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Body className="custom-scrollbar">
              <Tabs defaultActiveKey="parent" className="mb-3">
                <Tab
                  eventKey="parent"
                  title="Parent"
                  className="p-3"
                  disabled={isSubmitting}
                >
                  <ParentTabFields
                    values={values}
                    handleChange={handleChange}
                  />
                </Tab>
                <Tab
                  eventKey="emergency"
                  title="Emergency"
                  className="p-3"
                  disabled={isSubmitting}
                >
                  <EmergencyTabFields
                    values={values}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    emergencyRelation={data.emergencyRelation}
                  />
                </Tab>
                <Tab
                  eventKey="doctor"
                  title="Doctor"
                  className="p-3"
                  disabled={isSubmitting}
                >
                  <DoctorTabFields
                    values={values}
                    handleChange={handleChange}
                  />
                </Tab>
                <Tab
                  eventKey="other"
                  title="Additional Information"
                  className="p-3"
                  disabled={isSubmitting}
                >
                  <OthersTabFields
                    values={values}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                  />
                </Tab>
              </Tabs>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                type="button"
                size="sm"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                size="sm"
                disabled={isSubmitting}
              >
                Update
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
